import React, { useCallback } from 'react';
import {
    Cascader as AntdCascader,
    CascaderProps as AntdCascaderProps,
    ConfigProvider,
    MenuItemProps as AntdMenuItemProps,
    MenuProps as AntdMenuProps,
    CascaderPanelProps as AntdCascaderPanelProps,
} from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export interface CascaderProps extends AntdCascaderProps<any> {
    'data-test'?: string;
    'data-test-id'?: string;
}

export interface CascaderPanelProps extends AntdCascaderPanelProps<any> {
    'data-test'?: string;
    'data-test-id'?: string;
}

export type MenuProps = AntdMenuProps;
export type MenuItemProps = AntdMenuItemProps;

const Cascader: React.FC<CascaderProps> & { Panel: React.FC<CascaderPanelProps> } = (props) => {
    const theme = useTheme();

    const setTestIdAttributes = useCallback(() => {
        return new MutationObserver(() => {
            document.querySelectorAll('.ant-cascader-dropdown').forEach(dropdown => {
                if (dropdown && props['data-test-id']) {
                    const dropdownTestId = `${props['data-test-id']}-dropdown`;
                    dropdown.setAttribute('data-test-id', dropdownTestId);
                }

                const cascaderMenus = dropdown.querySelector('.ant-cascader-menus');
                if (cascaderMenus && props['data-test-id']) {
                    const menusTestId = `${props['data-test-id']}-menus`;
                    cascaderMenus.setAttribute('data-test-id', menusTestId);
                }

                const cascaderMenu = cascaderMenus?.querySelector('.ant-cascader-menu');
                if (cascaderMenu && props['data-test-id']) {
                    const menuTestId = `${props['data-test-id']}-menu`;
                    cascaderMenu.setAttribute('data-test-id', menuTestId);
                }
            });
        });
    }, [props['data-test-id']]);

    const handleVisibleChange = (visible: boolean) => {
        if (visible) {
            const observer = setTestIdAttributes();
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }
    };

    return (
        <ConfigProvider theme={theme}>
            <AntdCascader
                {...props}
                data-test={props['data-test']}
                data-test-id={props['data-test-id']}
                data-asper-cascader
                onPopupVisibleChange={handleVisibleChange} // Use correct prop
            />
        </ConfigProvider>
    );
};

const Panel: React.FC<CascaderPanelProps> = (props) => {
    const theme = useTheme();

    return (
        <ConfigProvider theme={theme}>
            <AntdCascader.Panel
                {...props}
                data-test={props['data-test']}
                data-test-id={props['data-test-id']}
                data-asper-cascader-panel
            />
        </ConfigProvider>
    );
};

Cascader.Panel = Panel;

export default Cascader;
